"use client";

import React, { memo } from "react";

import { cn } from "../utils";

interface AuroraTextProps {
  children: React.ReactNode;
  className?: string;
  colors?: string[];
  speed?: number;
}

export const AuroraText = memo(
  ({ children, className, speed = 1 }: AuroraTextProps) => {
    const gradientStyle = {
      backgroundImage: `linear-gradient(135deg, var(--color-primary), var(--color-secondary), var(--color-primary), var(--color-primary))`,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      animationDuration: `${10 / speed}s`,
      backgroundSize: "200% auto",
    };
    return (
      <span className={cn("relative inline-block", className)}>
        <span
          className="animate-aurora transform-none! bg-clip-text pr-px text-transparent brightness-110"
          style={gradientStyle}
        >
          {children}
        </span>
      </span>
    );
  },
);
